import { createContext, type ReactNode, useContext, useState } from "react";

interface FindingsDataContextType {
  recordsCount: {
    loadedRecordsCount: number;
    totalRecordsCount: number;
  };
  setRecordsCount: (count: {
    loadedRecordsCount: number;
    totalRecordsCount: number;
  }) => void;
}

const FindingsDataContext = createContext<FindingsDataContextType | undefined>(
  undefined,
);

export function FindingsDataProvider({ children }: { children: ReactNode }) {
  const [recordsCount, setRecordsCount] = useState({
    loadedRecordsCount: 0,
    totalRecordsCount: 0,
  });

  return (
    <FindingsDataContext.Provider value={{ recordsCount, setRecordsCount }}>
      {children}
    </FindingsDataContext.Provider>
  );
}

export function useFindingsData() {
  const context = useContext(FindingsDataContext);
  if (!context) {
    throw new Error("useFindingsData must be used within FindingsDataProvider");
  }
  return context;
}
